import React from "react";
import { RiseActionGroup } from "@/__generated__/types";
import { Badge } from "@/components/ui";
import { getActionTheme } from "./RiseAction/util";

export const ActionGroupBadge = ({
  actionGroup,
}: {
  actionGroup: RiseActionGroup;
}) => {
  const theme = getActionTheme(actionGroup);
  return (
    <Badge
      className={`${theme?.text} ${theme?.bg} ${theme?.border} h-[22px] rounded-xl`}
    >
      {actionGroup?.name}
    </Badge>
  );
};
